import React from 'react';
import { reportarErrorReact } from '../api';

/**
 * Evita la pantalla en blanco cuando un componente falla al dibujarse (por ejemplo, el navegador
 * traduciendo la página o una extensión que tocó el DOM de React). Reporta el error y deja al
 * usuario recargar sin perder la sesión.
 */
export default class ErrorBoundary extends React.Component {
  state = { fallo: false };

  static getDerivedStateFromError() {
    return { fallo: true };
  }

  componentDidCatch(error, info) {
    reportarErrorReact(error, info);
  }

  render() {
    if (!this.state.fallo) return this.props.children;
    return (
      <div className="empty-state" style={{ padding: 'var(--spacing-4)' }}>
        <p><strong>Algo salió mal al mostrar esta pantalla.</strong></p>
        <p className="text-sm">Tu información está a salvo. Si estabas pagando, revisa tu correo: si el cobro se aprobó, te llegará el comprobante.</p>
        <button className="btn-primary" onClick={() => window.location.reload()}>Recargar la página</button>
      </div>
    );
  }
}
